// Browser stub for protobufjs's `@protobufjs/inquire`.
//
// The real module does `require(moduleName)` in a try/catch to optionally load
// native deps (the `long` lib, Node's `buffer`). That dynamic require can't be
// statically resolved by the bundler ("Critical dependency: the request of a
// dependency is an expression"). In the browser those optional deps are never
// available, so always returning null is the correct behavior — and protobufjs
// handles null at every call site (util.Buffer try/catch; util.Long `|| ...`,
// which ts-proto overrides with an explicit `import Long from 'long'`).
//
// Aliased in rsbuild.config.ts so the dynamic require is removed at the source
// rather than suppressed as a warning.
module.exports = function inquire() {
  return null
}
